import React from "react";
import { Switch } from "wouter";
import { queryClient } from "./lib/queryClient";
import { QueryClientProvider } from "@tanstack/react-query";
import { Toaster } from "@/components/ui/toaster";
import { TooltipProvider } from "@/components/ui/tooltip";
import NotFound from "@/pages/not-found";
import { AuthProvider } from "@/hooks/use-auth";
import { ProtectedRoute } from "@/lib/protected-route";
import AuthPage from "@/pages/auth-page";
import HomePage from "@/pages/home-page";
import ProjectsPage from "@/pages/projects-page";
import ProjectDetailPage from "@/pages/project-detail-page";
import ProjectEditPage from "@/pages/project-edit-page";
import ClaimDetailPage from "@/pages/claim-detail-page";
import NewClaimPage from "@/pages/new-claim-page";
import OrganizationsPage from "@/pages/organizations-page";
import TenantManagementPage from "@/pages/tenant-settings-page";
import UserManagementPage from "@/pages/admin/users";
import AcceptInvitationPage from "@/pages/accept-invitation";
import { Route } from "wouter";

function Router() {
  console.log("[Router] Rendering router component");
  return (
    <Switch>
      <ProtectedRoute path="/" component={HomePage} />
      <ProtectedRoute path="/projects" component={ProjectsPage} />
      <ProtectedRoute path="/projects/:projectId/new-claim" component={NewClaimPage} />
      <ProtectedRoute path="/projects/:projectId/documents" component={ProjectDetailPage} />
      <ProtectedRoute path="/projects/:projectId/team" component={ProjectDetailPage} />
      <ProtectedRoute path="/projects/:projectId/edit" component={ProjectEditPage} />
      <ProtectedRoute path="/projects/:projectId" component={ProjectDetailPage} />
      <ProtectedRoute path="/claims/:claimId" component={ClaimDetailPage} />
      <ProtectedRoute path="/organizations" component={OrganizationsPage} />
      <ProtectedRoute path="/settings" component={TenantManagementPage} />
      <ProtectedRoute path="/admin/users" component={UserManagementPage} />
      <Route path="/auth" component={AuthPage} />
      <Route path="/accept-invitation" component={AcceptInvitationPage} />
      <Route component={NotFound} />
    </Switch>
  );
}

function App() {
  console.log("[App] Rendering main App component");
  return (
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <TooltipProvider>
          <Toaster />
          <Router />
        </TooltipProvider>
      </AuthProvider>
    </QueryClientProvider>
  );
}

export default App;
